/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'clock': {
    width: 16,
    height: 16,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16 16-7.2 16-16S24.8 0 16 0zm0 30C8.3 30 2 23.7 2 16S8.3 2 16 2s14 6.3 14 14-6.3 14-14 14zm3.7-9.7c.4.4.4 1 0 1.4-.4.4-1 .4-1.4 0l-4-4c-.2-.2-.3-.4-.3-.7v-6c0-.6.4-1 1-1s1 .4 1 1v5.6l3.7 3.7z"/>'
  }
})
